var React = require("react"); 

var ContentServerClient = require("../ContentServerClient.js");

class DisplayAssets extends React.Component {

    constructor() {
        super();

        this.moveAssetTypeHighlight = this.moveAssetTypeHighlight.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getGoodAssets = this.getGoodAssets.bind(this); 

        // The displayAssetType will tell us how to render the list of assets.
        // Buttons for switching the displayAssetType will be created based on the 
        // keys of the displayAssets object below
        this.state = { 
            displayAssets: [],
            displayAssetsType: ""
        };

        // If we want to display more asset types on the homepage,
        // all we need to do is add the new type here (which will create a new tab)
        // and add a getContent function below (with defaults and check logic if desired)
        this.displayAssetData = {
            // this object is now filled in inside Component did mount, using the properties
        }
    }
 
    componentWillMount() {
        Object.keys(this.props.tabs).map((keyName, keyIndex) => {
            var tab = this.props.tabs[keyName];
            this.displayAssetData[keyName] = [];
            this.getContent(keyName, tab.endpoint, tab.numberOfAssets, tab.defaultAssets, tab.condition, tab.assetCondition);
        })

        this.setState({displayAssetsType: this.props.tabs.defaultSelected, displayAssets: this.displayAssetData[this.props.tabs.defaultSelected]});

    }

    // string, int, array, function
    getContent(key, endpoint, num, defaults, searchCondition, resultCondition){
        // first we fill the list with default assets
        var defaultList = [];
        for(var i = 0; i < num; i++){
            if(i >= defaults.length) break;
            defaultList.push(defaults[i]);
        }
        this.displayAssetData[key] = defaultList;

        //defaultSelected Tap has the property endpoint 'undefined', that makes a request to '123D-Circuits/libraries?' which is unnecessary
        if(endpoint === undefined) return;
        // then we attempt to load better assets
        ContentServerClient.getFile(this.props.handleError, endpoint, searchCondition) // search for content with pin properties set to make sure we get good data
            .then(info => {
                var results = [];
                var assets = this.getGoodAssets(info.results, num, resultCondition);
                for(var i = 0; i < assets.length; i++){
                    results.push(assets[i]);
                }
                // but still fill the finished list with defaults,
                // if by chance we do not have enough data
                var defaultsNeeded = num - results.length;
                for(var i = 0; i < defaultsNeeded; i++){
                    if(i >= defaults.length) break;
                    results.push(defaults[i]);
                }
                this.displayAssetData[key] = results;
                // and render again if this type is shown
                if(this.state.displayAssetsType == key){
                    this.setState({displayAssets: results});
                }
            })
            .catch(err =>{
                // catch does nothing, our default cards will be 
                // used in this case.
            })
    }

     // find 'num' randomly selected assets from 'results' that 
    // satisfy the condition
    getGoodAssets(results, num, condition){
        var list = [];
        while(list.length < num && results.length > 0){
            var ind = Math.floor(Math.random()*results.length);
            var item = results[ind];
            results.splice(ind, 1);
            if(condition(item)){
                list.push(item);
            }
        }
        return list;
    }

    moveAssetTypeHighlight(event) {
        let elemt = event.target;
        let calc = elemt.getBoundingClientRect().x - this.contPointer.getBoundingClientRect().x;
        this.pointer.style.transform = `translateX(${calc}px)`;
        this.pointer.style.width = `${elemt.clientWidth}px`;
    }

    render(){  
        // displayAssetsType used to know how to render
        var assetType = this.state.displayAssetsType;
        var Card = this.props.tabs[assetType].CardType;
        return (
            <div className="container">
                <div className="intro__title">
                    <h3>Thousands of Packages and Libraries available for free.</h3>
                </div>
                {/* First render the tabs, and hook up the click logic */}
                <div className="intro__tap" ref={ptr => this.contPointer = ptr}>
                    {Object.keys(this.displayAssetData).map(buttonAssetType => 
                        <div className= {`intro__tap__option -${(buttonAssetType == assetType)?' active':''}`} 
                             key={buttonAssetType} 
                             onClick={event=> {
                                // on click, set the type and switch the data.
                                this.setState({
                                    displayAssetsType: buttonAssetType, 
                                    displayAssets: this.displayAssetData[buttonAssetType]
                                });
                                this.moveAssetTypeHighlight(event);
                            }
                        }>
                            {this.props.tabs[buttonAssetType].displayName}
                        </div>)}
                    <div className="intro__tap__pointer" ref={ptr => this.pointer = ptr}/>
                </div>

                {/* Then render the display assets.  (TODO make 3d model not an edge case, it needs its own card and style) */}
                <div className={`cards -${this.props.tabs[assetType].cssCardTag} -grid home`}>
                     {(this.state.displayAssets)?
                        this.state.displayAssets.map(item => <Card key={item.id} resource = {item} isPublicFacing/>)
                        : null 
                     }
                </div>

                <div className="intro__tap__buttonArea">
                    <button className="button" 
                            onClick={event => {
                                this.props.history.push(this.props.tabs[assetType].linkTo)
                            }}>
                        {this.props.tabs[assetType].linkName}
                    </button>
                </div>
            </div>
        )
    }

}


module.exports = DisplayAssets;